// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterDocumentsWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsRenterDocumentsWebApiHandler_addIncomeDocuments,
  CappsRenterDocumentsWebApiHandler_deleteDocument,
  CappsRenterDocumentsWebApiHandler_getEditorUrl,
  CappsRenterDocumentsWebApiHandler_getEditorUrl_Path,
  CappsRenterDocumentsWebApiHandler_requestUserToken,
  CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments,
  CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments_Path,
  CappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus,
} from '@zg-rentals/ts-capps-client';

import type {
  AddIncomeDocumentsWebApiRequestDto,
  DeleteDocumentWebApiRequestDto,
  GetEditorUrlWebApiResponseDto,
  IncomeDocumentWebApiDto,
  RequestUserTokenWebApiResponseDto,
  RetrieveActiveDocumentsWebApiResponseDto,
  SetDocumentRedactionStatusWebApiRequestDto,
} from '@zg-rentals/ts-capps-client';

interface GetEditorUrlParams {
  documentId: string;
}
interface RetrieveActiveDocumentsParams {
  documentIds: Array<string>;
}

export interface CappsRenterDocumentsWebApiHandler_addIncomeDocuments_Args {
  postData: AddIncomeDocumentsWebApiRequestDto;
}

export type CappsRenterDocumentsWebApiHandler_addIncomeDocuments_Options = UseMutationOptions<
  Array<IncomeDocumentWebApiDto>,
  unknown,
  CappsRenterDocumentsWebApiHandler_addIncomeDocuments_Args
>;

export const useCappsRenterDocumentsWebApiHandler_addIncomeDocuments = ({
  httpClient,
  ...options
}: Omit<CappsRenterDocumentsWebApiHandler_addIncomeDocuments_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterDocumentsWebApiHandler_addIncomeDocuments_Args) =>
      CappsRenterDocumentsWebApiHandler_addIncomeDocuments(args.postData, httpClient),
  });
};

export interface CappsRenterDocumentsWebApiHandler_deleteDocument_Args {
  postData: DeleteDocumentWebApiRequestDto;
}

export type CappsRenterDocumentsWebApiHandler_deleteDocument_Options = UseMutationOptions<
  void,
  unknown,
  CappsRenterDocumentsWebApiHandler_deleteDocument_Args
>;

export const useCappsRenterDocumentsWebApiHandler_deleteDocument = ({
  httpClient,
  ...options
}: Omit<CappsRenterDocumentsWebApiHandler_deleteDocument_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterDocumentsWebApiHandler_deleteDocument_Args) =>
      CappsRenterDocumentsWebApiHandler_deleteDocument(args.postData, httpClient),
  });
};

export type CappsRenterDocumentsWebApiHandler_getEditorUrl_Options = UseQueryOptions<
  GetEditorUrlWebApiResponseDto,
  unknown,
  GetEditorUrlWebApiResponseDto,
  readonly [string, GetEditorUrlParams]
>;

const CappsRenterDocumentsWebApiHandler_getEditorUrl_GetKey = (getParams: GetEditorUrlParams) =>
  [CappsRenterDocumentsWebApiHandler_getEditorUrl_Path, getParams] as const;

export const CappsRenterDocumentsWebApiHandler_getEditorUrl_queryOptions = (
  getParams: GetEditorUrlParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRenterDocumentsWebApiHandler_getEditorUrl_GetKey(getParams),
    queryFn: () => CappsRenterDocumentsWebApiHandler_getEditorUrl(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsRenterDocumentsWebApiHandler_getEditorUrl = (
  getParams: GetEditorUrlParams,
  {
    httpClient,
    ...options
  }: Omit<CappsRenterDocumentsWebApiHandler_getEditorUrl_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsRenterDocumentsWebApiHandler_getEditorUrl_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsRenterDocumentsWebApiHandler_getEditorUrl.getKey = CappsRenterDocumentsWebApiHandler_getEditorUrl_GetKey;

export type CappsRenterDocumentsWebApiHandler_requestUserToken_Options = UseMutationOptions<
  RequestUserTokenWebApiResponseDto,
  unknown,
  void
>;

export const useCappsRenterDocumentsWebApiHandler_requestUserToken = ({
  httpClient,
  ...options
}: Omit<CappsRenterDocumentsWebApiHandler_requestUserToken_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => CappsRenterDocumentsWebApiHandler_requestUserToken(httpClient),
  });
};

export type CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments_Options = UseQueryOptions<
  RetrieveActiveDocumentsWebApiResponseDto,
  unknown,
  RetrieveActiveDocumentsWebApiResponseDto,
  readonly [string, RetrieveActiveDocumentsParams]
>;

const CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments_GetKey = (getParams: RetrieveActiveDocumentsParams) =>
  [CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments_Path, getParams] as const;

export const CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments_queryOptions = (
  getParams: RetrieveActiveDocumentsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments_GetKey(getParams),
    queryFn: () => CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsRenterDocumentsWebApiHandler_retrieveActiveDocuments = (
  getParams: RetrieveActiveDocumentsParams,
  {
    httpClient,
    ...options
  }: Omit<CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsRenterDocumentsWebApiHandler_retrieveActiveDocuments.getKey =
  CappsRenterDocumentsWebApiHandler_retrieveActiveDocuments_GetKey;

export interface CappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus_Args {
  postData: SetDocumentRedactionStatusWebApiRequestDto;
}

export type CappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus_Options = UseMutationOptions<
  void,
  unknown,
  CappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus_Args
>;

export const useCappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus = ({
  httpClient,
  ...options
}: Omit<CappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus_Args) =>
      CappsRenterDocumentsWebApiHandler_setDocumentRedactionStatus(args.postData, httpClient),
  });
};
